var paramsToReset = ["page"];
export var resetQueryString = function resetQueryString(queryString) {
  paramsToReset.forEach(function (param) {
    delete queryString[param];
  });
  return queryString;
};